var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToolLineThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "icon-tool-line-thin",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-tool-line-thin1",
    serifid: "icon-tool-line-thin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.637,17.554c0.128,-0.245 0.033,-0.547 -0.211,-0.675l-20.389,-10.645c-0.244,-0.127 -0.547,-0.033 -0.674,0.212c-0.128,0.245 -0.033,0.547 0.211,0.675l20.389,10.645c0.244,0.127 0.547,0.033 0.674,-0.212Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolLineThin);
export default __webpack_public_path__ + "static/media/icon-tool-line-thin.7372b931c17f47884c851079e1a0e2cd.svg";
export { ForwardRef as ReactComponent };